import { ENetwork, isTestnet, web3Configs } from 'web3';

const ADDRESS_TEXT = '/address/';
const TX_TEXT = '/tx/';
const TOKEN_TEXT = '/token/';

export const calculateScanLink = ({
  address,
  network,
  addressType,
}: {
  address: string;
  network: ENetwork;
  addressType: 'transaction' | 'address' | 'token';
}): string => {
  const mapNetworkToAddressType = (network: ENetwork) => {
    const map: Partial<Record<ENetwork, any>> = {
      [ENetwork.airdao]: {
        transaction: 'transaction',
        address: 'address',
        token: 'address',
      },
    };

    return map[network] ? map[network][addressType] : addressType;
  };

  const type = mapNetworkToAddressType(network);

  let slug = '';
  if (type === 'transaction') {
    slug = [ENetwork.reef].includes(network) ? '/extrinsic/' : TX_TEXT;
  } else if (type === 'token') {
    slug = TOKEN_TEXT;
  } else if (type === 'address') {
    slug = [ENetwork.solana, ENetwork.reef].includes(network) ? '/account/' : ADDRESS_TEXT;
  }

  const scanUrl = web3Configs[network].scanUrl;

  const result = scanUrl + slug + address;
  if (network === ENetwork.solana && isTestnet) {
    result.concat('?cluster=testnet');
  }
  if (network === ENetwork.reef && type === 'transaction') {
    result.concat('/1');
  }

  return result;
};
